export enum AssigningBadgeType {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}
